import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {shareToSocialNetwork} from './utilities';

export const Icons = ({iconList}) => {
  return iconList?.map((element) => {

    return (
      <Image key={element?.name}
        className='icons'
        src={element?.image}
        onClick={() => window.open(shareToSocialNetwork(element?.socialNetworkId), '_blank')} />
    );
  });
};
